import React, { useState, useCallback, useContext } from 'react'
import { Button } from 'react-bootstrap'

import ClientOnly from '../../../ClientOnly';
import type { WhyReviewModalProps } from '../types';

import scss from '../BulkReviews.module.scss'
import { BulkReviewsContext, type BulkReviewsContextType } from '../context';

interface TopInfoSectionProps {
    showVideoSection: boolean;
}

const TopInfoSection = ({ showVideoSection } : TopInfoSectionProps) => {
    const [showVideoModal, setShowVideoModal] = useState<boolean>(false);

    const { loggedInUser, isLoggedIn } = useContext<BulkReviewsContextType>(BulkReviewsContext);

    const WhyReviewModal = React.lazy(() => import('./WhyReviewModal'));

    const hideReviewModal = useCallback(() => {
        setShowVideoModal(false)
    }, [setShowVideoModal])

    const showReviewModal = useCallback(() => {
        setShowVideoModal(true)
    }, [setShowVideoModal])

    const showLoginModal = useCallback(() => {
        window.location.href = "/login?returnUrl=" + window.location.pathname;
    }, [])

    return (
        <>
            { isLoggedIn ? 
            <div className={scss.loggedInUserSection}>
                Hi <span className={scss.userName}>{loggedInUser?.FirstName}</span>
                <div>Submitting reviews has never been easier.</div>
                <div>We've added your 'Booked' suppliers and pre-filled some information from your account to help you get started.</div>
            </div> :
            <div>
                Have an Easy Weddings account? Make it easy to review your suppliers and <button className={scss.modalOpenButton} onClick={showLoginModal}>log in for express submission.</button>
            </div> }
            <div className={scss.topInfoCards}>
                <div className="row w-100 m-auto">
                    <div className="col-2 col-md-auto pe-0 d-flex flex-wrap align-items-lg-center pt-3 pt-lg-0">
                        <i className={`fa-light fa-xl fa-memo-circle-info ${scss.infoCardIcons}`}></i>
                    </div>
                    <div className="col col-md ps-0">
                        <span>Did you know that your suppliers don't need to be on the Easy Weddings directory for you to review them? Add their business names below!</span>
                    </div>
                </div>
            </div>
            {showVideoSection && <div className={scss.topInfoCards}>
                <div className="row w-100 m-auto">
                    <div className="col-2 col-md-auto pe-0 d-flex flex-wrap align-items-lg-center">
                        <i className={`fa-light fa-xl fa-circle-play ${scss.infoCardIcons}`}></i>
                    </div>
                    <div className="col col-md d-flex flex-wrap align-items-center ps-0">
                        <span>Learn why your reviews are so important to future couples and the suppliers that you worked with.</span>
                        <div className="ms-lg-auto pt-2 pt-lg-0">
                            <Button variant="primary" onClick={showReviewModal}>Play Video</Button>
                        </div>
                    </div>
                </div>
            </div>}
            {showVideoModal && <ClientOnly<WhyReviewModalProps> Component={WhyReviewModal} showModal={showVideoModal} onHideModal={hideReviewModal} />}
        </>
    )
}

export default TopInfoSection